<div class="spinner-wrapper">
  <div class="spinner-ring"></div>
</div>
